export default "__VITE_ASSET__BBL3iyPV__"